import React from 'react';

const ParkingFlag = (props: object) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 26.25C21.2132 26.25 26.25 21.2132 26.25 15C26.25 8.7868 21.2132 3.75 15 3.75C8.7868 3.75 3.75 8.7868 3.75 15C3.75 21.2132 8.7868 26.25 15 26.25Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1875 16.875H15.9375C16.8077 16.875 17.6423 16.5293 18.2577 15.9139C18.873 15.2986 19.2188 14.464 19.2188 13.5938C19.2188 12.7235 18.873 11.8889 18.2577 11.2736C17.6423 10.6582 16.8077 10.3125 15.9375 10.3125H12.1875V19.6875"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ParkingFlag;
